import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authAPI from "../services/api";
import { Navigate } from "react-router-dom";
import { publicAxios } from "../api";

export const registerOtp = createAsyncThunk(
  "registerone/registerOtp",
  async ({ phone, type }, { rejectWithValue }) => {
    try {
      const response = await publicAxios.post(
        `/api/user/register/sendCode`,
        { phone, type },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error fetching perviews", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch orders"
      );
    }
  }
);

// export const registerVerifyOtp = createAsyncThunk(
//   "registerone/registerVerifyOtp",
//   async ({ phone, type, code }, { rejectWithValue }) => {
//     try {
//       const response = await publicAxios.post(
//         `/public/api/user/register/verifyCodenew`,
//         { phone, type, code },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.data.status) {
//         return rejectWithValue(response.data.message || "Invalid status.");
//       }

//       return response.data.data;
//     } catch (error) {
//       console.error("Error fetching perviews", error.message);
//       return rejectWithValue(
//         error.response?.data || error.request || "Failed to fetch orders"
//       );
//     }
//   }
// );

// export const registerVerifyOtp = createAsyncThunk(
//   "registerone/registerVerifyOtp",
//   async ({ phone, type, code }, { rejectWithValue }) => {
//     try {
//       const response = await publicAxios.post(
//         `/api/user/register/verifyCodenew`,
//         { phone, type, code },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.data.status) {
//         return rejectWithValue(response.data.message || "Invalid status.");
//       }

//       if (type === "sign_in") {
//         localStorage.setItem("token", response.data.data.user.token);
//       }

//       return response.data.data;
//     } catch (error) {
//       console.error("Error fetching previews", error.message);
//       return rejectWithValue(
//         error.response?.data || error.request || "Failed to fetch orders"
//       );
//     }
//   }
// );

// export const registerVerifyOtp = createAsyncThunk(
//   "registerone/registerVerifyOtp",
//   async ({ type, code }, { rejectWithValue, dispatch }) => {
//     try {
//       const response = await publicAxios.post(
//         `/api/user/register/verifyCodenew`,
//         { type, code , login_as : "user" },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.data.status) {
//         return rejectWithValue(response.data.message || "Invalid status.");
//       }

//       if (type === "sign_in") {
//         const user = response.data.data.user;

//         localStorage.setItem("token", user.token);
//         localStorage.setItem("user", JSON.stringify(user));

//         return { user, token: user.token };
//       }

//       return response.data.data;
//     } catch (error) {
//       console.error("Error during OTP verification", error.message);
//       return rejectWithValue(
//         error.response?.data || error.request || "Failed to verify OTP"
//       );
//     }
//   }
// );

export const registerVerifyOtp = createAsyncThunk(
  "registerone/registerVerifyOtp",
  async ({ type, code }, { rejectWithValue }) => {
    try {
      const response = await publicAxios.post(
        `/api/user/register/verifyCodenew`,
        { type, code, login_as: "user" },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Verify response:", response.data);

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Verification failed");
      }

      return { message: response.data.message };

    } catch (error) {
      console.error("Error during OTP verification", error);
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to verify OTP"
      );
    }
  }
);

export const signInVerifyOtp = createAsyncThunk(
  "signn/signInVerifyOtp",
  async ({ phone, type, code }, { rejectWithValue, dispatch }) => {
    try {
      const response = await publicAxios.post(
        `/api/user/register/verifyCodenew`,
        { phone, type, code, login_as: "user" },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      if (type === "sign_in") {
        const user = response.data.data.user;

        localStorage.setItem("token", user.token);
        localStorage.setItem("user", JSON.stringify(user));

        return { user, token: user.token };
      }

      return response.data.data;
    } catch (error) {
      console.error("Error during OTP verification", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to verify OTP"
      );
    }
  }
);


export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async (userData, thunkAPI) => {
    try {
      const response = await authAPI.register(userData);
      localStorage.setItem("token", response.data.data.user.token);
      // localStorage.setItem('user', JSON.stringify(response.data.data.user));
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const token = localStorage.getItem("token");
const user = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: user || null,
    // isAuthenticated: !!STATIC_TOKEN,
    isAuthenticated: !!token,
    isLoading: false,
    error: null,
  },
  reducers: {
    logoutUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
    setUser: (state, action) => {
      state.user = action.payload.user;
      state.isAuthenticated = true;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(action.payload.user));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.user;
        // state.isAuthenticated = !!token;
        state.isAuthenticated = true;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(registerOtp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(registerOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.user;
      })
      .addCase(registerOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(registerVerifyOtp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(registerVerifyOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.token) {
          state.user = action.payload.user;
          state.isAuthenticated = true;
        }
      })
      .addCase(registerVerifyOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(signInVerifyOtp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(signInVerifyOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.token) {
          state.user = action.payload.user;
          state.isAuthenticated = true;
        }
      })
      .addCase(signInVerifyOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { logoutUser, setUser } = authSlice.actions;
export default authSlice.reducer;
